<script>
// @ts-nocheck
import CurrencyInput from './CurrencyInput.svelte'
export let value = 0
export let type = _ => _
</script>

<CurrencyInput
    currency="ARS"
    isNegativeAllowed={false}
    maxLength={15}
    locale="es-AR"
    autocomplete="off"
    fractionDigits={2}
    onValueChange={r => {type(r)}}
    bind:value
/>

<style>
  /* Container */
  :global(div.currencyInput div.my-currency-input div.my-currency-input:focus) { 
    font-family: inherit;
    outline: none;
  }
  /* Formatted input */
  :global(input.currencyInput__formatted) { 
    border: none !important;
    border-bottom: 1px #c21b17 solid !important;
    font-family: inherit;
    font-size: 16px;
    outline: none;
}
</style>